'use client'

import Link from 'next/link'
import Image from 'next/image'
import { Trans } from 'react-i18next'
import { Grid, Typography, Divider, Button } from '@mui/material'

// Types
import type { CardProps } from '@/types/components/molecules/cards'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

const SlideshowBoxCardMolecule = (props: CardProps) => {
	// Props
	const { lng, title, link, year, subtitle, description, sx } = props

	// Variables
	const { t } = useTranslation(lng)

	return (
		<Grid
			container
			justifyContent="center"
			alignItems="center"
			direction="column"
			spacing={1}
			width={1}
			p={2}
			position="relative"
			textAlign="center"
			color="#fff"
			zIndex={5}
			sx={sx}
		>
			<Grid
				width={1}
				height={1}
				position="absolute"
				top={0}
				left={0}
				zIndex={-1}
				sx={{
					'& img': {
						width: 1,
						height: 1,
						objectFit: 'fill'
					}
				}}
			>
				<Image src="/images/parts/slideshow/union.png" alt="Slideshow union" width={659} height={277} />
			</Grid>

			{title && (
				<Grid size={12}>
					<Typography component="h4" fontSize={{ xs: 20, md: 39 }} fontWeight={700} lineHeight={1.15}>
						{title}
					</Typography>
				</Grid>
			)}

			{(year || subtitle) && (
				<Grid size={12}>
					<Grid container justifyContent="center" alignItems="center" spacing={2}>
						{year && (
							<Grid>
								<Typography component="span" fontSize={{ xs: 16, md: 24 }} fontWeight={700} lineHeight={1}>
									{year}
								</Typography>
							</Grid>
						)}

						{year && subtitle && <Divider orientation="vertical" flexItem sx={{ my: 0.5, bgcolor: '#fff' }} />}

						{subtitle && (
							<Grid>
								<Typography component="span" fontSize={{ xs: 16, md: 24 }} fontWeight={700} lineHeight={1}>
									{subtitle}
								</Typography>
							</Grid>
						)}
					</Grid>
				</Grid>
			)}

			{(description || link) && (
				<Grid size={12}>
					<Grid container spacing={1}>
						{description && (
							<Grid size={12}>
								<Typography component="p" fontSize={{ xs: 12, md: 16 }} fontWeight={700} lineHeight={1.15}>
									<Trans>{description}</Trans>
								</Typography>
							</Grid>
						)}

						{link && (
							<Grid size={12}>
								<Link href={`/${lng}${link}`}>
									<Button>{t('form:button.learnMore')}</Button>
								</Link>
							</Grid>
						)}
					</Grid>
				</Grid>
			)}
		</Grid>
	)
}

export default SlideshowBoxCardMolecule
